
export const PASSWORD_SIZE: number = 4;

const TEMP_DISCONNECTED_MIN: number = -31;
const TEMP_DISCONNECTED_MAX: number = 61;
const TENSION_DISCONNECTED_MIN: number = 1;
const TENSION_DISCONNECTED_MAX: number = 30;
export const IMAGE_PATH = './images/';

/**
 * Validate a format of an adress mail and returns a boolean accordingly
 * @param email 
 */
export function isEmailValid(email: string): boolean {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}


/**
 * Validate a format of an adress mail and returns a boolean accordingly
 * @param email 
 */
export function isPasswordValid(password: string): boolean {
  return password !== undefined && password.length >= 4;
}


/**
 * Check if temperature is in range
 * @param code 
 */
export function isTemperaturInRange(value: number): boolean {
  return (value !== undefined && !isNaN(value) && value >= TEMP_DISCONNECTED_MIN && value <= TEMP_DISCONNECTED_MAX);
}


/**
 * Check if tension is in range
 * @param code 
 */
export function isTensionInRange(value: number): boolean {
  return (value !== undefined && !isNaN(value) && value >= TENSION_DISCONNECTED_MIN && value <= TENSION_DISCONNECTED_MAX);
}

/**
 * Validate a format of a pairing code
 * @param code 
 */
export function isPairingCodeValid(code: string): boolean {
  return (code !== undefined && code !== '' && code.length >= 4);
}


/**
 * Validate a format of a name
 * @param code 
 */
export function isSiteNameValid(name: string): boolean {
  return !(name === undefined || name === '' || name.length < 4);
}

/**
 * Validate a format of a phone number and returns a boolean accordingly
 * @param phoneNumber 
 */
export function isPhoneNumberValid(phoneNumber: string): boolean {
  const re = /((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))/;
  return phoneNumber === '555' || re.test(String(phoneNumber).toLowerCase());
}

/**
 * Returns an object with only fields with different values + "no" field
 * @export
 * @param {*} refObject
 * @param {*} modifedObject
 * @returns {*}
 */
export function diffBetweenObject(refObject: any, modifedObject: any): any {
  // Only take different fields
  const objectWithChange: any = { no: modifedObject.no };
  for (const key in refObject) {
    if (refObject[key] !== modifedObject[key] && key !== 'lastValue') {
      objectWithChange[key] = modifedObject[key];
    }
  }
  return objectWithChange;
}


// WEBPACK FOOTER //
// ./src/util/util.ts